import React, { useMemo } from "react";

import { useSession } from "links/lib/contexts/session";
import { useSessionGameState } from "links/lib/contexts/sessionGameState";
import { useSessionTeachers } from "links/lib/contexts/sessionTeachers";
import {
  CoverImageBGColorSchemeType,
  CoverImageBGPatternType,
  CoverImageIconType,
  ISessionUser,
  WebSocketSession,
} from "links/lib/types";
import { useStudent } from "sessionComponents/contexts/student";
import { StudentLobby as TheStudentLobby } from "sessionComponents/organisms/StudentLobby";

export const StudentLobby: React.FC = () => {
  const session = useSession() as WebSocketSession;
  const student = useStudent();
  const gameState = useSessionGameState();
  const teachers = useSessionTeachers();
  const teachersList = Object.values(teachers).filter(
    (t) => !!t
  ) as ISessionUser[];
  // Currently will only be one teacher, revisit when we support more
  const teacher = teachersList[0];

  const {
    practice_set_title,
    practice_set_cover_image_bg_pattern,
    practice_set_cover_image_bg_color_scheme,
    practice_set_cover_image_icon,
    group_name,
  } = session;

  const practiceSet = useMemo(
    () => ({
      className: group_name || "",
      // default AdminCoverImage details since new teacher admin ui isn't started yet
      coverImageBGColorScheme: (practice_set_cover_image_bg_color_scheme ||
        "LIGHT_BLUE") as CoverImageBGColorSchemeType,
      coverImageIcon: (practice_set_cover_image_icon ||
        "OTHER_TRIVIA") as CoverImageIconType,
      coverImageBGPattern: (practice_set_cover_image_bg_pattern ||
        "OTHER_FUN_PARTY") as CoverImageBGPatternType,
      practiceSetName: practice_set_title as string,
      teacherTitle: teacher?.name || "",
    }),
    [
      practice_set_title,
      group_name,
      teacher,
      practice_set_cover_image_bg_pattern,
      practice_set_cover_image_bg_color_scheme,
      practice_set_cover_image_icon,
    ]
  );

  return (
    <TheStudentLobby
      outerGame={gameState?.game_type}
      student={student}
      practiceSet={practiceSet}
    />
  );
};
